import React from "react";
import useStableCallback from "./useStableCallback";

export function useLongPress(
  ref: React.RefObject<HTMLElement>,
  params: {
    duration: number;
    callback: () => void;
  }
) {
  const callbackRef = useStableCallback(params.callback);

  React.useEffect(() => {
    const element = ref.current;

    if (element === null) {
      return;
    }

    let timeoutId: NodeJS.Timeout | null = null;

    const handleTouchStart = () => {
      timeoutId = setTimeout(callbackRef, params.duration);
    };

    const handleTouchEnd = () => {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };

    element.addEventListener("touchstart", handleTouchStart);
    element.addEventListener("touchend", handleTouchEnd);

    return () => {
      element.removeEventListener("touchstart", handleTouchStart);
      element.removeEventListener("touchend", handleTouchEnd);
    };
  }, [ref, params.duration, callbackRef]);
}
